<template>
  <div class="qushi">
    <div class="section1">
      <div class="item1">
        <layout1 :title="'用电分析'">
          <div class="box">
            <div class="outer-round">
              <div class="inner-round">
                <p>{{ ElectricityAnalysis.item1 | genderMenu }}</p>
                <p>今日用电量（kWh)</p>
                <i class="iconfont icon-dian"></i>
              </div>
            </div>
            <div class="info-box">
              <div class="item">
                <div class="top">
                  <div class="legend"></div>
                  <p>较昨日同期变化</p>
                </div>
                <div class="bottom">
                  <i class="iconfont" :class="
                      ElectricityAnalysis.item2 >= 0
                        ? 'icon-shang'
                        : 'icon-xia color1'
                    "></i>
                  <span>{{
                    (Math.abs(ElectricityAnalysis.item2) * 100).toFixed(2)
                    }}%</span>
                </div>
              </div>
              <div class="item">
                <div class="top">
                  <div class="legend color1"></div>
                  <p>较上月同期变化</p>
                </div>
                <div class="bottom">
                  <i class="iconfont" :class="
                      ElectricityAnalysis.item3 >= 0
                        ? 'icon-shang'
                        : 'icon-xia color1'
                    "></i>
                  <span>{{
                    (Math.abs(ElectricityAnalysis.item3) * 100).toFixed(2)
                    }}%</span>
                </div>
              </div>
            </div>
          </div>
        </layout1>
      </div>
      <div class="item2">
        <layout1 :title="'占比统计'">
          <div class="box">
            <div class="left">
              <div class="mytable">
                <div class="th">
                  <span>类型</span>
                  <span>今日用电</span>
                  <span>日环比</span>
                  <span>月环比</span>
                </div>
                <div class="tr" v-for="(item, index) in zbList" :key="index">
                  <span>{{ comparisonObj[item.type] }}</span>
                  <span>{{ item.electric | genderMenu }}</span>
                  <span :class="item.dayHb < 0 ? 'color2' : 'color1'">
                    {{ item.dayHb | upordown }}
                    {{ item.dayHb | abs | genderMenu | per }}</span>
                  <span :class="item.monthHb < 0 ? 'color2' : 'color1'">
                    {{ item.monthHb | upordown }}
                    {{ item.monthHb | abs | genderMenu | per }}</span>
                </div>
              </div>
            </div>
            <div class="right">
              <v-chart :option="option1" ref="chart1"></v-chart>
            </div>
          </div>
        </layout1>
      </div>
      <div class="item3">
        <layout1 :title="'分项统计'">
          <div class="box">
            <div class="mytable">
              <div class="th">
                <span>类型</span>
                <span>今日用电</span>
                <span>日环比</span>
                <span>月环比</span>
              </div>
              <div class="tr" v-for="(item, index) in fxList" :key="index">
                <span>{{ item.subentryTypeName | genderMenu }}</span>
                <span> {{ item.todayPowerSub | genderMenu }}</span>
                <span :class="item.dayLoopSub < 0 ? 'color2' : 'color1'">
                  {{ item.dayLoopSub | upordown }}
                  {{ item.dayLoopSub | abs | genderMenu | per }}</span>
                <span :class="item.monthLoopSub < 0 ? 'color2' : 'color1'">
                  {{ item.monthLoopSub | upordown }}
                  {{ item.monthLoopSub | abs | genderMenu | per }}</span>
                <!-- <span class="color1">↑21%</span>
                <span class="color2">↓14%</span> -->
              </div>
            </div>
          </div>
        </layout1>
      </div>
    </div>
    <div class="section2">
      <layout1 :title="'用电统计'">
        <div class="box">
          <div class="top">
            <v-chart :option="option2" ref="chart2"></v-chart>
          </div>
          <div class="bottom">
            <div class="mytable">
              <div class="th">
                <span style="width: 4%; fontsize: 16px" v-for="(item, index) in tabelObj.th" :key="index">{{ item
                  }}</span>
              </div>
              <div class="tr" v-for="(item2, index2) in tabelObj.tabelArr" :key="index2">
                <span style="width: 4%" :style="{ fontSize: index == 0 ? '16px' : '14px' }"
                  v-for="(item, index) in item2" :key="index + 'cc'">{{ item | genderMenu }}</span>
              </div>
            </div>
          </div>
        </div>
      </layout1>
    </div>
  </div>
</template>

<script>
  import ECharts from "vue-echarts";
  import layout1 from "../layout/layout1";
  export default {
    components: { layout1, "v-chart": ECharts },
    data () {
      return {
        projectId: -1,
        comparisonObj: {
          1: "尖用电",
          2: "峰用电",
          3: "谷用电",
          4: "平用电",
        },
        ElectricityAnalysis: {}, // 用电分析
        fxList: [], // 分项统计
        zbList: [], // 占比统计
        option1: {
          color: [
            "rgba(53, 168, 255, 1)",
            "rgba(51, 204, 141, 1)",
            "rgba(252, 131, 86, 1)",
          ],
          legend: {
            data: ["今日用电", "昨日用电", "今日用电（上月）"],
          },
          tooltip: {},
          radar: {
            shape: "circle",
            splitArea: {
              show: false,
            },
            radius: "45%",
            name: {
              textStyle: {
                color: "#213150",
                fontSize: 13,
                borderRadius: 3,
              },
            },
            indicator: [
              { name: "尖用电", max: 0 },
              { name: "峰用电", max: 0 },
              { name: "平用电", max: 0 },
              { name: "谷用电", max: 0 },
            ],
          },
          series: [
            {
              type: "radar",
              name: "用电分布",
              data: [
                {
                  value: [],
                  name: "今日用电",
                  itemStyle: {
                    opacity: "0",
                  },
                  lineStyle: {
                    color: "rgba(53, 168, 255, 1)",
                  },
                  areaStyle: {
                    color: "rgba(53, 168, 255, 0.3)",
                  },
                },
                {
                  value: [],
                  name: "昨日用电",
                  itemStyle: {
                    opacity: "0",
                  },
                  lineStyle: {
                    color: "rgba(51, 204, 141, 1)",
                  },
                  areaStyle: {
                    color: "rgba(51, 204, 141, 0.3)",
                  },
                },
                {
                  value: [],
                  name: "今日用电（上月）",
                  itemStyle: {
                    opacity: "0",
                  },
                  lineStyle: {
                    color: "rgba(252, 131, 86, 1)",
                  },
                  areaStyle: {
                    color: "rgba(252, 131, 86, 0.3)",
                  },
                },
              ],
            },
          ],
        },
        option2ColorList: [
          "rgba(0, 166, 191, 1)",
          "rgba(251, 199, 2, 1)",
          "rgba(20, 108, 224, 1)",
          "rgba(122, 20, 224, 1)",
          "rgba(224, 20, 170, 1)",
          "rgba(203, 203, 203, 1)",
        ],
        option2: {
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: "cross",
              label: {
                backgroundColor: "#6a7985",
              },
            },
          },
          legend: {
            right: "5%",
            top: "4%",
            data: ["A相电压", "B相电压", "C相电压"],
          },
          color: [],
          grid: {
            left: "1%",
            right: "4%",
            bottom: "3%",
            top: "20%",
            containLabel: true,
          },
          xAxis: {
            type: "category",
            boundaryGap: false,
            axisLabel: {
              color: "rgba(158, 158, 168, 1)",
              fontSize: 14,
            },
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: { show: false },
            data: [
              "0时",
              "1时",
              "2时",
              "3时",
              "4时",
              "5时",
              "6时",
              "7时",
              "8时",
              "9时",
              "10时",
              "11时",
              "12时",
              "13时",
              "14时",
              "15时",
              "16时",
              "17时",
              "18时",
              "19时",
              "20时",
              "21时",
              "22时",
              "23时",
            ],
          },
          yAxis: {
            type: "value",
            axisLabel: {
              color: "rgba(158, 158, 168, 1)",
              fontSize: 14,
            },
            axisLine: { show: false },
            axisTick: { show: false },
            splitLine: {
              show: true,
              lineStyle: {
                color: "#E8E8E8",
              },
            },
          },
          series: [],
        },
        tabelObj: {
          th: [
            "编号",
            "0时",
            "1时",
            "2时",
            "3时",
            "4时",
            "5时",
            "6时",
            "7时",
            "8时",
            "9时",
            "10时",
            "11时",
            "12时",
            "13时",
            "14时",
            "15时",
            "16时",
            "17时",
            "18时",
            "19时",
            "20时",
            "21时",
            "22时",
            "23时",
          ],
        },
        topicList: [],
      };
    },
    created () {
      this.projectId = this.$getCookie("projectId");
      this.searchElectricSubentryStatistics();
      this.searchElectAnalysis();
      this.searchProportionAnalysis();
      this.searchElectricStackSubItem();
    },
    methods: {
      // 右上角分项分析
      searchElectricSubentryStatistics () {
        this.$http
          .post(
            "bma-distribution-service/realTime/searchElectricSubentryStatistics",
            {
              projectId: this.projectId,
              dataType: 1,
            }
          )
          .then((res) => {
            // 以环比的正负来判断 字体颜色
            let arr = [];
            res.data.forEach((item) => {
              let obj = Object.assign({}, item);
              delete obj.subscribeFields;
              arr.push(obj);
            });
            this.fxList = arr;
            res.data.forEach((item) => {
              item.subscribeFields.forEach((j) => {
                if (this.topicList.indexOf(j.subscribeField) == -1) {
                  this.topicList.push(j.subscribeField);
                }
                this.$timeing(j.subscribeField, j.subscribeField, (res2) => {
                  const data = JSON.parse(res2.body);
                  let str = data.field.split("/")[1];
                  const index = str.substr(str.length - 1, 1);
                  const key = str.substr(0, str.length - 1);

                  this.fxList[index - 1][key] = data.value - 0;
                });
              });
            });
          });
      },
      // 左上角用电分析
      searchElectAnalysis () {
        this.$http
          .post("bma-distribution-service/realTime/searchElectAnalysis", {
            projectId: this.projectId,
            dataType: 1,
          })
          .then((res) => {
            let obj = {
              item1: res.data.electricToday,
              item2: res.data.yesterdayCompare,
              item3: res.data.lastMonthCompare,
            };
            this.ElectricityAnalysis = obj;
            // 订阅
            res.data.subscribeFields.forEach((item) => {
              if (this.topicList.indexOf(item.subscribeField) == -1) {
                this.topicList.push(item.subscribeField);
              }
              this.$timeing(item.subscribeField, item.subscribeField, (res) => {
                let data = JSON.parse(res.body);
                if (data.field.indexOf("todayTotalPower") > -1) {
                  this.ElectricityAnalysis.item1 = data.value;
                } else if (data.field.indexOf("yesChangePower") > -1) {
                  this.ElectricityAnalysis.item2 = data.value;
                } else if (data.field.indexOf("monthChangePower") > -1) {
                  this.ElectricityAnalysis.item3 = data.value;
                }
              });
            });
          });
      },
      // 中上 占比统计
      searchProportionAnalysis () {
        this.$http
          .post("bma-distribution-service/realTime/searchProportionAnalysis", {
            projectId: this.projectId,
            dataType: 1,
          })
          .then((res) => {
            this.zbList = res.data.tipPeakValleyFlatList;
            let list = res.data.tipPeakValleyFlatList;
            let legend = [];
            let indicator = [];
            let data1 = [];
            let data2 = [];
            let data3 = [];
            let maxElectric = 0;
            list.forEach((item) => {
              if (Number(item.maxElectric) > Number(maxElectric)) {
                maxElectric = Number(item.maxElectric);
              }
            });
            list.forEach((item) => {
              legend.push(this.comparisonObj[item.type]);
              indicator.push({
                name: this.comparisonObj[item.type],
                max: maxElectric,
              });
              data1.push(item.electric);
              data2.push(item.dayElectric);
              data3.push(item.monthElectric);
            });
            // // 返回值的maxElectric算的不对
            // indicator.forEach((item, index) => {
            //   let max = Math.max(data1[index], data2[index], data3[index]);
            //   item.max = max;
            // });
            // this.option1.legend.data = legend;
            this.option1.radar.indicator = indicator;
            this.option1.series[0].data[0].value = data1;
            this.option1.series[0].data[1].value = data2;
            this.option1.series[0].data[2].value = data3;
            this.$refs.chart1.setOption(this.option1, true);
            this.setStomp(res.data.subscribeFields);
          });
      },
      setStomp (subscribeFields) {
        if (subscribeFields) {
          subscribeFields.forEach((item) => {
            if (this.topicList.indexOf(item.subscribeField) == -1) {
              this.topicList.push(item.subscribeField);
            }
            this.$timeing(item.subscribeField, item.subscribeField, (res) => {
              let data = JSON.parse(res.body);
              // alert(JSON.stringify(res.body))
              if (data.field.indexOf("sharpPowerToday") > -1) {
                this.zbList[0].electric = data.value;
              } else if (data.field.indexOf("sharpDayLoop") > -1) {
                this.zbList[0].dayHb = data.value;
              } else if (data.field.indexOf("sharpMonthLoop") > -1) {
                this.zbList[0].monthHb = data.value;
              } else if (data.field.indexOf("peakPowerToday") > -1) {
                this.zbList[1].electric = data.value;
              } else if (data.field.indexOf("peakDayLoop") > -1) {
                this.zbList[1].dayHb = data.value;
              } else if (data.field.indexOf("peakMonthLoop") > -1) {
                this.zbList[1].monthHb = data.value;
              } else if (data.field.indexOf("grainPowerToday") > -1) {
                this.zbList[2].electric = data.value;
              } else if (data.field.indexOf("grainDayLoop") > -1) {
                this.zbList[2].dayHb = data.value;
              } else if (data.field.indexOf("grainMonthLoop") > -1) {
                this.zbList[2].monthHb = data.value;
              } else if (data.field.indexOf("flatPowerToday") > -1) {
                this.zbList[3].electric = data.value;
              } else if (data.field.indexOf("flagDayLoop") > -1) {
                this.zbList[3].dayHb = data.value;
              } else if (data.field.indexOf("flagMonthLoop") > -1) {
                this.zbList[3].monthHb = data.value;
              }
              let list = this.zbList;
              let legend = [];
              let indicator = [];
              let data1 = [];
              let data2 = [];
              let data3 = [];
              let maxElectric = 0;
              list.forEach((item) => {
                if (Number(item.maxElectric) > Number(maxElectric)) {
                  maxElectric = Number(item.maxElectric);
                }
              });
              list.forEach((item) => {
                legend.push(this.comparisonObj[item.type]);
                indicator.push({
                  name: this.comparisonObj[item.type],
                  max: maxElectric,
                });
                data1.push(item.electric);
                data2.push(item.dayElectric);
                data3.push(item.monthElectric);
              });
              // // 返回值的maxElectric算的不对
              // indicator.forEach((item, index) => {
              //   let max = Math.max(data1[index], data2[index], data3[index]);
              //   item.max = max;
              // });
              // this.option1.legend.data = legend;
              this.option1.radar.indicator = indicator;
              this.option1.series[0].data[0].value = data1;
              this.option1.series[0].data[1].value = data2;
              this.option1.series[0].data[2].value = data3;
              this.$refs.chart1.setOption(this.option1, true);
            });
          });
        }
      },
      // 底部折线图
      searchElectricStackSubItem () {
        this.$http
          .post("bma-distribution-service/realTime/searchElectricStackSubItem", {
            projectId: this.projectId,
            dataType: 1,
          })
          .then((res) => {
            // 图表用
            let legend = [];
            let seriesArr = [];
            let option2ColorList = this.option2ColorList;
            // 表格用
            let tabelArr = [];
            res.data.forEach((item, index) => {
              // 折线图
              let temp = {
                name: "",
                type: "line",
                symbolSize: 0,
                areaStyle: {
                  color: {
                    type: "linear",
                    x: 0,
                    y: 0,
                    x2: 0,
                    y2: 1,
                    colorStops: [
                      {
                        offset: 0,
                        color: "", // 0% 处的颜色
                      },
                      {
                        offset: 1,
                        color: "", // 100% 处的颜色
                      },
                    ],
                    global: false, // 缺省为 false
                  },
                },
                data: [],
              };
              legend.push(item.subentryTypeName);
              temp.name = item.subentryTypeName;
              temp.areaStyle.color.colorStops[0].color = this.option2ColorList[
                index
              ].replace("1)", "0.5)");
              temp.areaStyle.color.colorStops[1].color = this.option2ColorList[
                index
              ].replace("1)", "0)");
              let dataArr = [];
              for (let i = 1; i <= 24; i++) {
                dataArr.push(item.electricEnergySub ? 0 : "-");
              }
              // if(item.electricEnergySub===null){

              // }else{

              // }
              console.log('00000')
              console.log(item.electricEnergySub)
              for (let i in item.electricEnergySub) {
                let h = i.substring(i.length - 2);
                dataArr[Number(h)] = this.$genderMenu(item.electricEnergySub[i]);
              }
              temp.data = dataArr;
              let temp2 = Object.assign({}, temp);
              seriesArr.push(temp2);

              // 表格
              let dataArr2 = [];
              for (let i = 1; i <= 24; i++) {
                dataArr2.push(item.electricEnergySub ? 0 : "-");
              }
              for (let i in item.electricEnergySub) {

                let h = i.substring(i.length - 2);
                dataArr2[Number(h)] = item.electricEnergySub[i];
              }
              dataArr2.unshift(item.subentryTypeName.replace("用电", ""));
              tabelArr.push(dataArr2);
            });
            this.option2.color = this.option2ColorList;
            this.option2.legend.data = legend;
            this.option2.series = seriesArr;

            this.tabelObj.tabelArr = tabelArr;

            // 实时
            res.data.forEach((item) => {
              item.subscribeFields.forEach((j) => {
                if (this.topicList.indexOf(j.subscribeField) == -1) {
                  this.topicList.push(j.subscribeField);
                }
                this.$timeing(j.subscribeField, j.subscribeField, (res2) => {

                  const data = JSON.parse(res2.body);
                  //  alert(JSON.stringify(res2.body))
                  let str = data.field.split("/")[1];
                  const index = str.substr(str.length - 1, 1);
                  const key = str.substr(0, str.length - 1);
                  let innerIndex = Number(data.time.match(/\s(\S{2}):/)[1])
                  let innerValue = this.option2.series[index - 1].data[
                    innerIndex
                  ] === '-' ? 0 : this.option2.series[index - 1].data[
                  innerIndex
                  ];
                  console.log('777777777')
                  console.log(this.option2)
                  // 图表
                  this.option2.series[index - 1].data[innerIndex] = (
                    Number(innerValue) + Number(data.value)
                  ).toFixed(2);
                  this.$refs.chart2.setOption(this.option2, true);
                  // 表格   .toFixed(2)
                  this.tabelObj.tabelArr[index - 1][Number(innerIndex) + 1] = (
                    Number(innerValue) + Number(data.value)
                  ).toString();
                  console.log('99999999')
                  console.log(this.tabelObj)
                  this.$forceUpdate();
                });
              });
            });
          });
      },
    },
    filters: {
      upordown (v) {
        if (v < 0) {
          return "⬇";
        } else if (v > 0) {
          return "⬆";
        } else {
          return "";
        }
      },
    },
    beforeDestroy () {
      this.topicList.forEach((item) => {
        this.$clearTimeing(item);
      });
    },
  };
</script>

<style lang="less" scoped>
  .qushi {
    padding: 15px;
    background: #ececec;

    .section1 {
      display: flex;
      justify-content: space-between;

      .item1 {
        width: 23%;
        // width: 380px;
        height: 349px;

        .box {
          padding-right: 26px;
          padding-bottom: 26px;
          box-sizing: border-box;

          .outer-round {
            width: 164px;
            height: 164px;
            background: #ffffff;
            border: 1px solid #eeeeee;
            border-radius: 50%;
            box-sizing: border-box;
            padding: 8px;
            margin: 25px auto 0;

            .inner-round {
              border: 1px solid rgba(86, 180, 252, 1);
              box-sizing: border-box;
              width: 148px;
              height: 148px;
              background: #ffffff;
              border-radius: 50%;
              position: relative;
              text-align: center;

              i {
                color: rgba(118, 196, 255, 0.5);
                font-size: 110px;
                z-index: 0;
                line-height: 148px;
              }

              p {
                position: absolute;
                text-align: center;
                width: 100%;

                &:first-of-type {
                  font-size: 24px;
                  color: #393a3f;
                  font-weight: 600;
                  top: 50px;
                  margin-bottom: 10px;
                }

                &:last-of-type {
                  top: 84px;
                  font-size: 13px;
                  color: #717789;
                }
              }
            }
          }

          .info-box {
            display: flex;
            justify-content: space-between;
            margin-top: 33px;

            .item {
              .top {
                display: flex;
                align-items: center;

                .legend {
                  width: 17px;
                  height: 4px;
                  background: #56b4fc;
                  margin-right: 6px;

                  &.color1 {
                    background: rgba(51, 204, 141, 1);
                  }
                }

                p {
                  font-size: 14px;
                }
              }

              .bottom {
                margin-top: 20px;
                text-align: center;

                i {
                  color: rgba(252, 86, 86, 1);
                  font-size: 14px;

                  &.color1 {
                    color: #56b4fc;
                  }
                }

                span {
                  font-size: 22px;
                  font-weight: 600;
                }
              }
            }
          }
        }
      }

      .item2 {
        // width: 710px;
        width: 50%;
        height: 349px;

        .box {
          display: flex;
          align-items: center;
          margin-top: 20px;

          .left {
            width: 388px;
          }

          .right {
            width: 280px;
            height: 280px;
          }
        }
      }

      .item3 {
        // width: 524px;
        width: 26%;
        height: 349px;

        .box {
          padding-right: 26px;
          padding-bottom: 20px;
          overflow-y: scroll;
          margin-top: 15px;
        }
      }
    }

    .section2 {
      width: 100%;
      // width: 1633px;
      height: 744px;
      margin-top: 10px;

      .box {

        // width: 100%;
        // height: 100%;
        .top {
          width: 100%;
          height: 350px;
        }
      }
    }
  }

  .mytable {
    width: 100%;
    height: 240px;
    border-top: 1px solid #e1e1e1;

    .th {
      background: #f5f5f5;
    }

    .th,
    .tr {
      display: flex;
      text-align: center;
      height: 46px;
      border-left: 1px solid #e1e1e1;

      span {
        width: 120px;
        line-height: 46px;
        border-right: 1px solid #e1e1e1;
        border-bottom: 1px solid #e1e1e1;
        font-size: 14px;

        &:first-of-type {
          background: #f5f5f5;
          font-weight: 600;
        }
      }
    }

    .th {
      span {
        font-size: 12px;
        font-weight: 600;
      }
    }

    .tr {
      span {
        &.color1 {
          color: #fc5656;
        }

        &.color2 {
          color: #33cc8d;
        }
      }
    }
  }

  @media screen and (max-width: 1440px) {
    .common {
      .title {
        font-size: 16px;
      }
    }

    .left {
      width: 40%;

      .count {
        >p {
          font-size: 16px;
        }

        >.cright {
          p {
            &:first-of-type {
              font-size: 45px;
            }

            &:last-of-type {
              font-size: 16px;
              color: #152139;
            }
          }
        }
      }
    }

    .middle {
      width: 25%;
    }
  }
</style>